export default {
  defaultObject () {
    return {
      id: null,
      name: '',
      units: []
    }
  }
}